<template>
  <span>
    <strong
      v-for="(subcategory, index) in disallowedSubcategories"
      :key="index"
    >
      <translate :tt="{ subcategory }">{subcategory} not allowed</translate>
      &nbsp;
    </strong>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({})
class BookingDisallowedSubcategories extends Vue {
  @Prop()
  disallowedSubcategories: string[]
}

export default toNative(BookingDisallowedSubcategories)
</script>
